<div class="flex flex-col gap-4 p-2 font-['Inter']">
  <h2 class="text-primary text-2xl font-bold" i18n="@@headerNavDashboard">Dashboard</h2>
  <div class="grid grid-cols-4 gap-4">
    @for (stat of stats; track stat.labelAr) {
      <div
        class="flex items-center justify-between rounded-xl bg-white p-5 shadow-sm transition-shadow hover:shadow-md">
        <div class="flex flex-col gap-1">
          <span class="text-2xl font-bold text-gray-900">
            {{ stat.value }}
            <span i18n="@@egp">EGP</span>
            @if (stat.labelEn == "Total Earnings") {
              <span class="text-sm font-normal text-gray-500"></span>
            }
          </span>
          <span class="text-sm font-medium text-gray-500">
            {{ isArabic() ? stat.labelAr : stat.labelEn }}
          </span>
          <div class="mt-1 flex items-center gap-1 text-xs font-semibold">
            <span [class]="stat.increasing ? 'text-green-500' : 'text-red-500'">
              {{ stat.change }}
            </span>
            <svg
              [class]="stat.increasing ? 'text-green-500' : 'text-red-500'"
              [class.rotate-180]="!stat.increasing"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path d="m18 15-6-6-6 6" />
            </svg>
            @if (!stat.increasing) {
              <span class="text-[10px] font-normal whitespace-nowrap text-gray-400">
                {{ isArabic() ? "من الشهر الماضي" : "Last Month" }}
              </span>
            }
          </div>
        </div>
        <div class="bg-border-subtle text-primary flex h-12 w-12 items-center justify-center rounded-full">
          @if (stat.labelEn == "Orders") {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 2048 2048">
              <path
                class="fill-primary"
                d="m2029 1453l-557 558l-269-270l90-90l179 178l467-466zM1024 640H640V512h384zm0 256H640V768h384zm-384 128h384v128H640zM512 640H384V512h128zm0 256H384V768h128zm-128 128h128v128H384zm768-384V128H256v1792h896v128H128V0h1115l549 549v731l-128 128V640zm128-128h293l-293-293z" />
            </svg>
          }
          @if (stat.labelEn == "New Users") {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          }
          @if (stat.labelEn == "Pharmacies") {
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 48 48">
              <g class="stroke-primary fill-primary" stroke-width="1">
                <path
                  fill-rule="evenodd"
                  d="M18.862 8.353c-.568 1.332-.614 3.037-.557 4.647H37c.552 0 1.006.45.943.998c-.385 3.365-2.699 6.293-6.066 8.097c.085.393.123.798.123 1.208c0 1.819-1.377 3.255-2.849 4.167A10.6 10.6 0 0 1 26 28.759v-2.067a8.6 8.6 0 0 0 2.099-.923C29.377 24.978 30 24.066 30 23.303q0-.185-.014-.356c-1.497.557-3.14.912-4.871 1.019V32h-2v-8.022c-6.898-.338-12.442-4.6-13.058-9.98c-.063-.548.39-.998.943-.998h5.304c-.057-1.633-.021-3.698.718-5.431c.424-.995 1.09-1.91 2.113-2.566C20.155 4.35 21.452 4 23.058 4c1.967 0 3.567.714 4.656 1.406c.547.347.975.695 1.27.959a8 8 0 0 1 .466.455l.01.01l.002.004l.002.001s0 .002-.734.653l.735-.651a1 1 0 0 1-1.495 1.328l-.01-.011l-.058-.06a6 6 0 0 0-.253-.24a8 8 0 0 0-1.007-.76C25.762 6.536 24.533 6 23.058 6c-1.316 0-2.215.284-2.843.686c-.624.4-1.055.967-1.353 1.667M12.306 15c1.175 3.76 5.667 7 11.694 7s10.52-3.24 11.694-7z"
                  clip-rule="evenodd" />
                <path
                  d="M16 42v2h16v-2h-3.019c.66-.812 1.019-1.835 1.019-3c0-1.545-.632-2.84-1.757-3.724C27.143 34.413 25.655 34 24 34c-1.483 0-2.8-.13-3.719-.539c-.441-.196-.747-.438-.946-.722c-.194-.277-.335-.664-.335-1.24c0-.574.14-.96.335-1.238c.199-.284.505-.526.946-.722c.477-.212 1.06-.35 1.719-.432v-2.014c-.894.096-1.77.28-2.531.618c-.684.304-1.315.75-1.773 1.403c-.462.66-.696 1.461-.696 2.386s.234 1.726.696 2.386c.458.653 1.09 1.099 1.773 1.403c1.33.591 3.014.71 4.531.71c1.346 0 2.356.338 3.007.85c.625.49.993 1.196.993 2.15c0 .956-.368 1.661-.993 2.152c-.457.359-1.09.632-1.892.763V38h-2v4z" />
              </g>
            </svg>
          }
          @if (stat.labelEn == "Total Earnings") {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                class="fill-primary"
                fill-rule="evenodd"
                d="M11.948 1.25h.104c.899 0 1.648 0 2.242.08c.628.084 1.195.27 1.65.725c.456.456.642 1.023.726 1.65c.06.44.075.964.079 1.57c.648.021 1.226.06 1.74.128c1.172.158 2.121.49 2.87 1.238c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153H9.944c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-.112c0-1.838 0-3.294.153-4.433c.158-1.172.49-2.121 1.238-2.87c.749-.748 1.698-1.08 2.87-1.238a18 18 0 0 1 1.74-.128c.004-.606.02-1.13.079-1.57c.084-.627.27-1.194.725-1.65c.456-.455 1.023-.64 1.65-.725c.595-.08 1.345-.08 2.243-.08M8.752 5.252q.567-.003 1.192-.002h4.112q.625 0 1.192.002c-.004-.57-.018-1-.064-1.347c-.063-.461-.17-.659-.3-.789s-.328-.237-.79-.3c-.482-.064-1.13-.066-2.094-.066s-1.612.002-2.095.067c-.461.062-.659.169-.789.3s-.237.327-.3.788c-.046.346-.06.776-.064 1.347M5.71 6.89c-1.006.135-1.586.389-2.01.812c-.422.423-.676 1.003-.811 2.009c-.138 1.027-.14 2.382-.14 4.289s.002 3.262.14 4.29c.135 1.005.389 1.585.812 2.008s1.003.677 2.009.812c1.028.138 2.382.14 4.289.14h4c1.907 0 3.262-.002 4.29-.14c1.005-.135 1.585-.389 2.008-.812s.677-1.003.812-2.009c.138-1.027.14-2.382.14-4.289s-.002-3.261-.14-4.29c-.135-1.005-.389-1.585-.812-2.008s-1.003-.677-2.009-.812c-1.027-.138-2.382-.14-4.289-.14h-4c-1.907 0-3.261.002-4.29.14M12 9.25a.75.75 0 0 1 .75.75v.01c1.089.274 2 1.133 2 2.323a.75.75 0 0 1-1.5 0c0-.384-.426-.916-1.25-.916s-1.25.532-1.25.916s.426.917 1.25.917c1.385 0 2.75.96 2.75 2.417c0 1.19-.911 2.048-2 2.323V18a.75.75 0 0 1-1.5 0v-.01c-1.089-.274-2-1.133-2-2.323a.75.75 0 0 1 1.5 0c0 .384.426.916 1.25.916s1.25-.532 1.25-.916s-.426-.917-1.25-.917c-1.385 0-2.75-.96-2.75-2.417c0-1.19.911-2.049 2-2.323V10a.75.75 0 0 1 .75-.75"
                clip-rule="evenodd" />
            </svg>
          }
        </div>
      </div>
    }
  </div>
  <div class="grid grid-cols-1 gap-4">
    <div class="rounded-xl bg-white p-6 shadow-sm">
      <div class="mb-4 flex items-center justify-between">
        <h3 i18n="@@userSidebarOrders" class="text-lg font-medium text-gray-900">Orders</h3>
        <select
          (change)="onYearChange($event)"
          class="rounded-md border border-gray-200 bg-white px-3 py-1 text-sm text-gray-600 outline-none hover:border-gray-300">
          @for (year of years; track year) {
            <option [value]="year" [selected]="year == selectedYear">{{ year }}</option>
          }
        </select>
      </div>
      <div class="h-[250px] w-full">
        <apx-chart
          [series]="ordersChartOptions.series"
          [chart]="ordersChartOptions.chart"
          [xaxis]="ordersChartOptions.xaxis"
          [grid]="ordersChartOptions.grid"
          [plotOptions]="ordersChartOptions.plotOptions"
          [dataLabels]="ordersChartOptions.dataLabels"
          [colors]="ordersChartOptions.colors"
          [tooltip]="ordersChartOptions.tooltip"
          [states]="ordersChartOptions.states"></apx-chart>
      </div>
    </div>
    <div class="rounded-xl bg-white p-6 shadow-sm">
      <div class="mb-4 flex items-center justify-between">
        <h3 i18n="@@totalEarnings" class="text-lg font-medium text-gray-900">Total Earnings</h3>
        <select
          class="rounded-md border border-gray-200 bg-white px-3 py-1 text-sm text-gray-600 outline-none hover:border-gray-300">
          <option value="2020">2020</option>
        </select>
      </div>
      <div class="h-[250px] w-full">
        <apx-chart
          [series]="earningsChartOptions.series"
          [chart]="earningsChartOptions.chart"
          [xaxis]="earningsChartOptions.xaxis"
          [grid]="earningsChartOptions.grid"
          [plotOptions]="earningsChartOptions.plotOptions"
          [dataLabels]="earningsChartOptions.dataLabels"
          [colors]="earningsChartOptions.colors"
          [tooltip]="earningsChartOptions.tooltip"
          [states]="earningsChartOptions.states"></apx-chart>
      </div>
    </div>
  </div>
</div>
